import React from "react";
import ReactDOM from "react-dom";
import { ThemeProviderWrapper } from "@selfpub/selfpub-ui";
import ShowNewPublicOfferModal from "scripts/share/components/ShowNewPublicOfferModal";
import { GlobalStyle } from "scripts/share/components/ShowNewPublicOfferModal/styles";

const renderOfferModal = isUserAcceptNewOffer => {
  const onAccept = () => {
    location.reload();
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(ThemeProviderWrapper, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(ShowNewPublicOfferModal, {
    enable: !isUserAcceptNewOffer,
    submitCallback: onAccept
  }))), document.getElementById("offer-modal"));
};

export { renderOfferModal };